module.exports = __webpack_public_path__ + "components/home-header/static/header-5--small@2x-af9b23dee3106ef7d1d4121aa7727548.jpg";